/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {FmlxButton, FmlxIcon, FmlxModal} from 'fmlx-common-ui';
import {Col, Form, Row} from 'react-bootstrap';
import {Get, Post} from '../../lib/Request';
import {ALERT_VARIANT, PaginationEnum} from '../../const/dataEnum';
import {setAlert} from '../../stores/actions/alertModalStateAction';
import {API_ACTION, API_ROLE, API_ROLE_LEVEL} from '../../const/Api';
import {getDefaultValue} from '../../lib/utilities';
import EssSimpleTable from '../../components/MessageTable/TableColumn/EssSimpleTable';
import {usePagination} from '../../hooks/usePagination';
import './ManageRoleLevel.scss';

export default function ManageRoleLevel() {
  const dispatch = useDispatch();
  const defaultRoleLevel = getDefaultValue('roleLevel');

  const [loadingRoleLevel, setLoadingRoleLevel] = useState(true);
  const [role, setRole] = useState([]);
  const [roleID, setRoleID] = useState(0);
  const [roleLevel, setRoleLevel] = useState([]);
  const [roleLevelName, setRoleLevelName] = useState('');
  const [roleLevelDescription, setRoleLevelDescription] = useState('');
  const [roleLevelID, setRoleLevelID] = useState(0);
  const [action, setAction] = useState('');
  const [loadingModify, setLoadingModify] = useState(false);

  useEffect(() => {
    fetchRoleLevel();
    fetchRole();
  }, []);

  const mappedRoleLevelData = roleLevel.map((item, index) => ({
    id: item.id,
    index: index + 1,
    roleLevelName: item.roleLevelName,
    roleName: item.role?.roleName,
    roleLevelDescription: item.roleLevelDescription,
    action: '',
  }));

  const {
    page,
    rowsPerPage,
    slicedData: filteredData,
    handleChangePage,
    handleChangeRowsPerPage,
    pageOptions,
    MemoizedEmptyRows,
  } = usePagination(mappedRoleLevelData, {}, PaginationEnum.PAGE_OPTIONS);

  const columnData = [
    {
      id: 'index',
      Header: '#',
      accessor: 'index',
      sortable: false,
      renderCell: (_, row) => row.index,
    },
    {
      id: 'roleLevelName',
      Header: 'Role Level Name',
      accessor: 'roleLevelName',
      sortable: false,
      renderCell: (_, row) => row.roleLevelName,
    },
    {
      id: 'roleName',
      Header: 'Role',
      accessor: 'roleName',
      sortable: false,
      renderCell: (_, row) => row.roleName,
    },
    {
      id: 'roleLevelDescription',
      Header: 'Description',
      accessor: 'roleLevelDescription',
      sortable: false,
      renderCell: (_, row) => row.roleLevelDescription,
    },
    {
      id: 'action',
      Header: 'Action',
      accessor: 'action',
      sortable: false,
      renderCell: (_, row) => (
        <div className="action-buttons">
          <FmlxButton
            type={FmlxButton.Type.PRIMARY}
            size={FmlxButton.Size.LARGE}
            onlyIcon
            withTooltip
            tooltipDescription="Edit"
            icon={<FmlxIcon name="Editor" />}
            onClick={() => {
              setRoleLevelID(row.id);
              setRoleID(roleLevel.find((r) => r.id === row.id)?.roleID ?? 0);
              setRoleLevelName(row.roleLevelName);
              setRoleLevelDescription(row.roleLevelDescription);
              setAction('Update');
            }}
          />

          <FmlxButton
            type={FmlxButton.Type.DANGER}
            size={FmlxButton.Size.LARGE}
            onlyIcon
            withTooltip
            tooltipDescription="Delete"
            icon={<FmlxIcon name="Trash" />}
            onClick={() => {
              setRoleLevelID(row.id);
              setRoleID(roleLevel.find((r) => r.id === row.id)?.roleID ?? 0);
              setRoleLevelName(row.roleLevelName);
              setRoleLevelDescription(row.roleLevelDescription);
              setAction('Delete');
            }}
          />
        </div>
      ),
    },
  ];

  function callError(result) {
    if (result.responseCode !== 0) {
      dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: result.message}));
      return true;
    }
    return false;
  }

  async function fetchRoleLevel() {
    setLoadingRoleLevel(true);
    let result = await Get(API_ROLE_LEVEL);
    if (!callError(result)) {
      await setRoleLevel(result.data);
    }
    setLoadingRoleLevel(false);
  }

  async function fetchRole() {
    let result = await Get(API_ROLE);
    if (!callError(result)) {
      await setRole(result.data);
    }
  }

  function validateEntry() {
    return roleLevelName.length > 0 && roleID > 0;
  }
  function resetForm() {
    setAction('');
    setRoleLevelID(defaultRoleLevel.id);
    setRoleID(defaultRoleLevel.roleID);
    setRoleLevelName(defaultRoleLevel.roleLevelName);
    setRoleLevelDescription(defaultRoleLevel.roleLevelDescription);
  }

  async function ModifyRoleLevel(event) {
    event.preventDefault();
    setLoadingModify(true);

    let param = {...defaultRoleLevel};
    let url;
    switch (action) {
      case 'Create':
        param.roleLevelName = roleLevelName;
        param.roleID = roleID;
        param.roleLevelDescription = roleLevelDescription;
        url = API_ROLE_LEVEL + API_ACTION.CREATE;
        break;
      case 'Update':
        param.id = roleLevelID;
        param.roleLevelName = roleLevelName;
        param.roleID = roleID;
        param.roleLevelDescription = roleLevelDescription;
        url = API_ROLE_LEVEL + API_ACTION.UPDATE;
        break;
      case 'Delete':
        param.id = roleLevelID;
        url = API_ROLE_LEVEL + API_ACTION.DELETE;
        break;
      default:
        return;
    }
    let result = await Post(url, param);
    if (!callError(result)) {
      dispatch(setAlert({show: true, variant: ALERT_VARIANT.SUCCESS, message: result.message}));
      await fetchRoleLevel();
    } else if (result.responseCode === -9) {
      dispatch(
        setAlert({
          show: true,
          variant: ALERT_VARIANT.ERROR,
          message:
            action === 'Delete'
              ? `RoleLevel ${roleLevelName} cannot be deleted because there is/are employee(s) associated with the ${roleLevelName} RoleLevel`
              : 'The data is invalid',
        })
      );
    } else {
      dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: result.message}));
    }
    resetForm();
    setLoadingModify(false);
  }

  const body = (
    <>
      <div className="create-button">
        <FmlxButton
          type={FmlxButton.Type.PRIMARY}
          size={FmlxButton.Size.MEDIUM}
          label="Add Role Level"
          onClick={() => {
            resetForm();
            setAction('Create');
          }}
        />
      </div>
      <EssSimpleTable
        columnData={columnData}
        filteredData={filteredData}
        renderEmptyData={MemoizedEmptyRows}
        dataCount={{length: roleLevel.length}}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        onPageOption={pageOptions}
        sortTableDirection={''}
        sortKey={''}
        isLoading={loadingRoleLevel}
      />
    </>
  );

  const deletePrompt = (
    <FmlxModal
      open={action === 'Delete'}
      onCloseClick={() => {
        setAction('');
        setRoleLevelID(0);
      }}
      size={FmlxModal.Size.MEDIUM}
      title="Delete RoleLevel"
      primaryButton={{
        show: true,
        disabled: loadingModify,
        label: 'Yes',
        type: FmlxButton.Type.DANGER,
        variant: FmlxButton.Variant.CONTAIN,
        onClick: (e) => ModifyRoleLevel(e),
      }}
      secondaryButton={{
        show: true,
        disabled: loadingModify,
        label: 'Cancel',
        type: FmlxButton.Type.BASIC,
        variant: FmlxButton.Variant.PLAIN,
        onClick: () => {
          setAction('');
          setRoleLevelID(0);
        },
      }}
      tertiaryButton={{
        show: false,
      }}
    >
      <p>Are you sure to delete this RoleLevel?</p>
    </FmlxModal>
  );

  const createOrUpdatePrompt = (
    <FmlxModal
      open={['Create', 'Update'].includes(action)}
      onCloseClick={() => {
        resetForm();
      }}
      size={FmlxModal.Size.LARGE}
      title={`${action} RoleLevel`}
      primaryButton={{
        show: true,
        disabled: !validateEntry() || loadingModify,
        label: 'Save Changes',
        type: FmlxButton.Type.PRIMARY,
        variant: FmlxButton.Variant.CONTAIN,
        onClick: (e) => ModifyRoleLevel(e),
      }}
      secondaryButton={{
        show: true,
        disabled: loadingModify,
        label: 'Close',
        type: FmlxButton.Type.BASIC,
        variant: FmlxButton.Variant.PLAIN,
        onClick: () => {
          resetForm();
        },
      }}
      tertiaryButton={{
        show: false,
      }}
    >
      <Form onSubmit={ModifyRoleLevel}>
        <Row>
          <Col>
            <Form.Group size="lg" controlId="rolelevel" className="mb-2">
              <Form.Label>Role Level Name</Form.Label>
              <Form.Control
                autoFocus
                placeholder="Role Level"
                type="text"
                value={roleLevelName}
                onChange={(e) => setRoleLevelName(e.target.value)}
              />
            </Form.Group>
            <Form.Group size="lg" controlId="role" className="mb-2">
              <Form.Label>Role</Form.Label>
              <Form.Select value={roleID} onChange={(e) => setRoleID(e.target.value)}>
                <option>Select Option</option>
                {role.map((comp) => (
                  <option key={comp.id} value={comp.id}>
                    {comp.roleName}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group size="lg" controlId="roleDes" className="mb-2">
              <Form.Label>RoleLevel Description</Form.Label>
              <Form.Control
                placeholder="Role Level Description"
                type="text"
                value={roleLevelDescription}
                onChange={(e) => setRoleLevelDescription(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </FmlxModal>
  );

  return (
    <div className="container manage-role-level">
      {body}
      {deletePrompt}
      {createOrUpdatePrompt}
    </div>
  );
}
